import { render, staticRenderFns } from "./NoAnswer.container.vue?vue&type=template&id=e4071c32&scoped=true&"
import script from "./NoAnswer.container.vue?vue&type=script&lang=js&"
export * from "./NoAnswer.container.vue?vue&type=script&lang=js&"
import style0 from "./NoAnswer.container.vue?vue&type=style&index=0&id=e4071c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4071c32",
  null
  
)

export default component.exports